module.exports = __webpack_public_path__ + "static/media/icon.10cb8121.svg";